// api constant
import {API_BASE_URL} from 'constant'

export function signInUser(data){
  const url = `${API_BASE_URL}/auth/signin`;
  return (
    fetch(url, {
      method:"POST",
      headers:{
        "Accept": "application/json",
        "Content-type": "application/json",
      },
      body:JSON.stringify(data)
    })
    .then(response => (
      response.json().then(json => {
        if(!response.ok) { 
          return Promise.reject(json);
        }
        console.log("sigin response", json)
        localStorage.setItem('role', json.roles[0])
        return json;
      })
    ))
  )
}

export function passwordEmail(data){
  const url = `${API_BASE_URL}/auth/reset/admin`;

  return (
    fetch(url, {
      method:"POST",
      headers:{
        "Accept": "application/json",
        "Content-type": "application/json",
      },
      body:JSON.stringify(data)
    })
  )
}

export function passwordReset(data){
  const url = `${API_BASE_URL}/auth/reset/password/admin`;
  return (
    fetch(url, {
      method:"POST",
      headers:{
        "Accept": "application/json",
        "Content-type": "application/json",
      },
      body:JSON.stringify(data)
    })
  );
}
